import { FaFileAlt, FaImage } from 'react-icons/fa'
import { SelectFolder } from './SelectFolder'
import { useState } from 'react'
import { FiChevronDown } from 'react-icons/fi'
import { FaCircleCheck } from 'react-icons/fa6'
import { IoDocumentText } from 'react-icons/io5'
import { MdOutlineOndemandVideo } from 'react-icons/md'

export function SelectPairing({ files = [], folders = [], employees = [], selectedFolder, selectedEmployees = [], onChange, value = [] }) {
	const selectedFolderObj = folders.find(f => f.name === selectedFolder || f.id === selectedFolder)
	const [openIdx, setOpenIdx] = useState(null)

	function getRootParent(folders, folder) {
		let current = folder
		while (current && current.parentId !== null) {
			current = folders.find(f => f.id === current.parentId)
		}
		return current
	}

	const rootParent = selectedFolderObj ? getRootParent(folders, selectedFolderObj) : null

	const isComum = rootParent && rootParent.private === false && rootParent.parentId === null
	const isParticular = rootParent && rootParent.private === true && rootParent.parentId === null

	let folderTree = []
	if (isComum && rootParent) {
		folderTree = [rootParent, ...folders.filter(f => getRootParent(folders, f)?.id === rootParent.id && f.id !== rootParent.id)]
	}

	const getSelectedValue = idx => value[idx] || (isComum ? selectedFolder : null)

	const handleSelect = (fileIdx, optionId) => {
		const newValue = [...value]
		newValue[fileIdx] = optionId
		onChange(newValue)
	}
	const limitName = name => (name && name.length > 24 ? name.slice(0, 21) + '...' : name)

	const simpleEmployees = employees.map(emp => ({
		id: emp.id,
		name: emp.name,
		area: emp.area?.profileArea || '',
		level: emp.level?.PositionN || '',
	}))

	const getIconByExtension = fileName => {
		const ext = (fileName || '').toLowerCase().split('.').pop()
		const docExts = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt']
		const videoExts = ['mp4', 'mov', 'avi', 'mkv', 'webm']
		const imgExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'tiff', 'ico']

		if (docExts.includes(ext)) return <IoDocumentText className='tw-text-blue-500 tw-h-4 tw-w-4' />
		if (videoExts.includes(ext)) return <MdOutlineOndemandVideo className='tw-text-red-500 tw-h-4 tw-w-4' />
		if (imgExts.includes(ext)) return <FaImage className='tw-text-green-500 tw-h-4 tw-w-4' />

		return <IoDocumentText className='tw-text-gray-400 tw-h-4 tw-w-4' />
	}

	return (
		<table className='tw-w-full tw-text-sm'>
			<thead>
				<tr className='border-bottom tw-text-gray-400'>
					<th className='tw-text-left tw-py-2 tw-px-2'>Documento</th>
					<th className='tw-text-left tw-py-2 tw-px-2'>{isComum ? 'Pasta' : isParticular ? 'Colaborador' : ''}</th>
				</tr>
			</thead>
			<tbody>
				{files.map((file, idx) => (
					<tr key={idx} className='border-bottom tw-items-center'>
						<td className='tw-py-2 tw-px-2 tw-align-middle'>
							<div className='tw-flex tw-items-center tw-h-10 tw-gap-3'>
								{getIconByExtension(file.name || file)}
								<span className='tw-text-gray-700 tw-text-sm tw-font-semibold tw-flex tw-items-center tw-h-10'>{limitName(file.name || file)}</span>
							</div>
						</td>
						<td className='tw-py-2 tw-px-2 tw-relative tw-align-middle' style={{ minWidth: 260, maxWidth: 320 }}>
							<div className='tw-flex tw-items-center tw-w-full'>
								<div className='tw-w-full tw-max-w-[240px]'>
									<div className='tw-flex tw-items-center'>
										{isComum && (
											<div className='tw-w-full'>
												<SelectFolder
													folders={folderTree}
													selectedFolder={getSelectedValue(idx)}
													onSelect={folderId => handleSelect(idx, folderId)}
												/>
											</div>
										)}
										{isParticular && (
											<div className='tw-relative tw-w-full'>
												<div
													className='border tw-border-[#4F46E5] tw-rounded-lg tw-px-4 tw-pr-2 tw-h-10 tw-flex tw-items-center tw-justify-between tw-bg-white tw-cursor-pointer tw-w-full'
													onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
													style={{ minWidth: 0 }}
												>
													<span className={`tw-text-gray-700 ${getSelectedValue(idx) ? '' : 'tw-text-gray-500'} tw-text-sm tw-truncate`}>
														{getSelectedValue(idx) ? simpleEmployees.find(emp => emp.id === Number(getSelectedValue(idx)))?.name : 'Selecionar'}
													</span>
													<FiChevronDown className='tw-ml-2 tw-text-black' />
												</div>
												{openIdx === idx && (
													<div className='tw-absolute tw-z-10 tw-w-full tw-bg-white border tw-rounded-lg tw-mt-1 tw-shadow-lg tw-max-h-60 tw-overflow-y-auto'>
														{simpleEmployees.filter(emp => selectedEmployees.includes(emp.id)).length > 0 ? (
															simpleEmployees
																.filter(emp => selectedEmployees.includes(emp.id))
																.map(emp => (
																	<div
																		key={emp.id}
																		className='tw-px-4 tw-py-2 tw-cursor-pointer hover:tw-bg-gray-100 tw-text-gray-700 tw-text-sm tw-h-10 tw-flex tw-items-center'
																		onClick={() => {
																			handleSelect(idx, emp.id)
																			setOpenIdx(null)
																		}}
																	>
																		{emp.name}
																	</div>
																))
														) : (
															<div className='tw-p-4 tw-text-gray-400'>Ningún colaborador disponible</div>
														)}
													</div>
												)}
											</div>
										)}
									</div>
								</div>
							</div>
							{getSelectedValue(idx) && (
								<span className='tw-absolute tw-right-2 tw-top-1/2 -tw-translate-y-1/2'>
									<FaCircleCheck className='tw-text-green-500 tw-font-bold tw-h-5 tw-w-5' />
								</span>
							)}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	)
}
